module.exports = __webpack_public_path__ + "static/media/seismicwave.95474553.svg";